module.exports = __webpack_public_path__ + "static/media/4.82ac0e5f.png";